export const STRING = 'string';
export const NUMBER = 'number';
export const INTEGER = 'integer';
